// import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import React, { useState } from "react";
// import { useContext } from "react";
import { useNavigate } from "react-router-dom";
// import { ThemeContext } from "../../hook/ThemeProvider";
import { footerData, NavbarsData } from "../../assets/data/Data";
import "./style.css";

const Navbar = () => {
  // const { colorTheme, setTheme } = useContext(ThemeContext);

  // const handleThemeChange = (value) => {
  //   setTheme(value);
  //   localStorage.setItem("color-theme", value);
  // };

  // const defaultTheme = colorTheme;

  const [activeTab, setActiveTab] = useState(1);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();

  const handleTabClick = (id, path) => {
    setActiveTab(id);
    setOpenDropdown(null);
    navigate(path);
  };

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  return (
    <nav className="bg-white fixed w-full z-50 shadow dark:bg-primary-darkBg">
      <div className="mx-auto xmax-w-[75rem] px-4 sm:px-6 lg:px-8 xhidden sm:block">
        <div className="relative flex h-16 items-center justify-between">
          <div
            className="flex flex-shrink-0 items-center flex-col cursor-pointer"
            onClick={() => navigate("/")}
          >
            <h5 className="text-lg font-bold font-roboto text-white">
              GOOD VIBZ
            </h5>
            <span className="-mt-3 tracking-widest">promotion</span>
          </div>
          <div className="inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 md:pr-8">
            <div className="md:flex items-center hidden">
              {NavbarsData.map((navItem) => (
                <div key={navItem.id} className="relative">
                  <div
                    onClick={() => {
                      if (!navItem.subNavs) {
                        handleTabClick(navItem.id, navItem.path);
                      } else {
                        toggleDropdown(navItem.id);
                      }
                    }}
                    className="cursor-pointer flex items-center space-x-1 rounded-md px-3 py-2 text-base font-sourceSans font-semibold capitalize"
                  >
                    <span
                      className={`text-[16px] font-poppins font-medium capitalize ${
                        activeTab === navItem.id
                          ? "dark:text-primary "
                          : "dark:text-white"
                      }`}
                    >
                      {navItem.title}
                    </span>
                    {navItem.subNavs && (
                      <svg
                        className={`w-4 h-4 transition-transform duration-300 ${
                          openDropdown === navItem.id ? "rotate-180" : ""
                        }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        ></path>
                      </svg>
                    )}
                  </div>

                  {navItem.subNavs && openDropdown === navItem.id && (
                    <div className="absolute left-0 mt-[14px] w-48 bg-white shadow-lg rounded-md capitalize">
                      {navItem.subNavs.map((subNav, index) => (
                        <span
                          key={index}
                          className="block px-4 py-1.5 text-base cursor-pointer font-semibold font-poppins"
                          onClick={() => {
                            navigate(subNav.path);
                            setOpenDropdown(null);
                          }}
                        >
                          {subNav.title}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* <div className="flex gap-x-2 items-center ml-14">
              <div>
                {defaultTheme === "dark" ? (
                  <MoonOutlined
                    className="transform transition-transform duration-200 ease-in-out hover:scale-110 relative rounded-full bg-secondary p-1.5 dark:text-white focus:outline-none focus:ring-1 focus:ring-offset-1 text-xl"
                    onClick={() => handleThemeChange("light")}
                  />
                ) : (
                  <SunOutlined
                    className="transform transition-transform duration-200 ease-in-out hover:scale-110 relative rounded-full bg-[#d0eff5] p-1.5 text-primary focus:outline-none focus:ring-1 focus:ring-offset-1 text-xl"
                    onClick={() => handleThemeChange("dark")}
                  />
                )}
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="header-bottom-actions bg-white dark:bg-primary-darkBg">
        <div className="flex items-center justify-between w-full px-6 mx-6">
          {footerData?.map((el) => (
            <button key={el?.id} onClick={() => navigate(el?.path)}>
              <div className="flex flex-col items-center">{el?.icon}</div>
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
